import apiHandler from '../core/apiHandler';

export default apiHandler('restaurant/kitchen-orders');
